import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { updateExtractedFields } from '../../utils/redux/actions';

const WordMapper = ({ dispatch, page, extractedFields, originalWidth, originalHeight, classes, fieldToBeUpdated }) => {
	const [keyDown, setKeyDown] = useState(false); //hold variable for keyDown event

	const handleKeyDown = (e) => {
		const eventReseter = (e) => {
			if (e.key === 'Shift') {
				setKeyDown(false);
			}
		};

		if (e.key === 'Shift' && !keyDown && fieldToBeUpdated) {
			setKeyDown(true);
			document.addEventListener('keyup', eventReseter, { once: true });
		}
	};

	const updateInputWord = (actualElement, previousElement, selectedWord) => {
		/**
		 * Handle click event to updating the input value,
		 * adding a className to the selected word and
		 * removing the previous, if there is one.
		 */
		if (previousElement) {
			for (let i = 0; i < previousElement.length; i++) {
				previousElement[i].classList.remove('selected');
			}
		} //removing class from previous element(s)

		actualElement.classList.add('selected'); //adding class to the actual element
		if (extractedFields[fieldToBeUpdated.fieldValue]) {
			dispatch(
				updateExtractedFields({
					...extractedFields,
					[fieldToBeUpdated.fieldValue]: {
						...extractedFields[fieldToBeUpdated.fieldValue],
						word: selectedWord.word,
						bbox: selectedWord.bbox,
					},
				})
			); //Update input field in Redux.
		} else {
			dispatch(
				updateExtractedFields({
					...extractedFields,
					[fieldToBeUpdated.fieldValue]: {
						...extractedFields[fieldToBeUpdated.fieldValue],
						word: selectedWord.word,
						bbox: selectedWord.bbox,
						displayName: fieldToBeUpdated.displayName,
					},
				})
			); //Update input field in Redux.
		}
	};

	const concatSecondValue = (actualElement, selectedWord) => {
		/**
		 * Handle click and keyDown events to concatenate
		 * a new value with an existing input value(s) and
		 * add a className to the newly selected word.
		 */
		let wordToUpdate = extractedFields[fieldToBeUpdated.fieldValue].word; //define word to be updated

		actualElement.classList.add('selected'); //adding class to the actual element
		if (wordToUpdate.replace(/\s/g, '').length) {
			wordToUpdate += wordToUpdate.endsWith(' ') ? selectedWord : ` ${selectedWord}`;
		}
		if (extractedFields[fieldToBeUpdated.fieldValue]) {
			dispatch(
				updateExtractedFields({
					...extractedFields,
					[fieldToBeUpdated.fieldValue]: {
						...extractedFields[fieldToBeUpdated.fieldValue],
						word: wordToUpdate,
					},
				})
			); //Update input field in Redux.
		} else {
			dispatch(
				updateExtractedFields({
					...extractedFields,
					[fieldToBeUpdated.fieldValue]: {
						...extractedFields[fieldToBeUpdated.fieldValue],
						word: wordToUpdate,
						displayName: fieldToBeUpdated.displayName,
					},
				})
			); //Update input field in Redux.
		}
	};

	useEffect(() => {
		document.addEventListener('keydown', handleKeyDown); // handle key down event to concat more values
		return () => {
			document.removeEventListener('keydown', handleKeyDown); //clear keydown event
		};
	});

	return (
		<svg className={classes} width='100%' viewBox={`0 0 ${originalWidth} ${originalHeight}`} xmlns='http://www.w3.org/2000/svg'>
			<image width='100%' height='100%' href={page.pageUrl} />
			{fieldToBeUpdated &&
				page.pageWords.map(({ word, bbox }, index) => {
					const x = bbox[0] - 5;
					const y = bbox[1] - 5;
					const width = bbox[2] + 5 - x;
					const height = bbox[3] + 5 - y;

					return (
						<rect
							className='hocr-word pointer'
							key={index}
							rx='5px'
							fill='transparent'
							x={x}
							y={y}
							width={width}
							height={height}
							onClick={(e) => {
								if (!e.target.classList.contains('selected')) {
									keyDown ? concatSecondValue(e.target, word) : updateInputWord(e.target, document.querySelectorAll('rect.selected'), { word, bbox });
								}
							}}
						/>
					);
				})}
		</svg>
	);
};

/**
 * Take the pages saved in redux and return it
 * in components props.
 */
const mapStateToProps = ({ savedDocument: { extractedFields, originalWidth, originalHeight } }) => ({ extractedFields, originalWidth, originalHeight });

export default connect(mapStateToProps)(WordMapper); //Export component and connect it with redux.
